import { CmsDataService } from '@omnia/ui/src/lib'
import type { InitialData } from './models/initialData'

export class CurzonCmsDataService extends CmsDataService<InitialData> {
    public get initialData() {
        const { occConfiguration, occConfigurationOverride } = this.get()
        return { ...occConfiguration, occConfigurationOverride }
    }
}

export const cmsDataService = new CurzonCmsDataService()
